import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui-pages/src/project/widget/widget.tsx");
